import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import React from 'react';
import { countries, findCountry } from '../../../utils/countries';

const CountrySelect = ({ label, helperText, errorText, fullWidth, value = 'US', onChange, countryFilter, ...other }) => {
  return (<FormControl error fullWidth={fullWidth}>
    <InputLabel htmlFor="name-error">{label}</InputLabel>
    <Select
      value={value && value.code ? value.code : value}
      onChange={(code) => onChange(findCountry(code))}
      name={label}
    >
      {countries.map((country) => {
        return (<MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>);
      })}
    </Select>
    {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    {errorText ? <FormHelperText>{errorText}</FormHelperText> : null}
  </FormControl>);

  // return (<Select
  //   label={label}
  //   value={value && value.code ? value.code : value}
  //   onChange={(evt) => {
  //     const code = evt.target.value;
  //     return onChange(findCountry(code));
  //   }}
  //   {...other}
  //   id="country"
  //   placeholder="Country"
  // >
  //   {countries.map((country) => {
  //     return (<MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>);
  //   })}
  // </Select>);
};

export default CountrySelect;



// WEBPACK FOOTER //
// ./src/components/Common/CountrySelect/index.js